import { Badge } from "@shopify/polaris";

type Tone = "success" | "info" | "attention" | "warning" | "critical" | undefined;

const toneByStatus: Record<string, Tone> = {
  Ready: "success",
  Complete: "success",
  Submitted: "success",
  Running: "info",
  Queued: "attention",
  "Not started": "attention",
  Draft: "attention",
  "Ready to submit": "attention",
  "Needs rules": "warning",
  Review: "warning",
  "Needs attention": "warning",
  "Preflight warning": "warning",
  Hold: "warning",
  Missing: "critical",
  Blocked: "critical",
  Failed: "critical"
};

export function StatusBadge({ status }: { status: string }) {
  return <Badge tone={toneByStatus[status]}>{status}</Badge>;
}
